export class Institution {
  id: number;
  firstName: string;
  lastName: string;
}
